export const REQUEST_ORDERS = 'REQUEST_ORDERS';
export const RECEIVE_ORDERS = 'RECEIVE_ORDERS';
export const REQUEST_QUOTES = 'REQUEST_QUOTES';
export const RECEIVE_QUOTES = 'RECEIVE_QUOTES';
export const REQUEST_ORDER_DATES = 'REQUEST_ORDER_DATES';
export const RECEIVE_ORDER_DATES = 'RECEIVE_ORDER_DATES';
export const REQUEST_QUOTE_DATES = 'REQUEST_QUOTE_DATES';
export const RECEIVE_QUOTE_DATES = 'RECEIVE_QUOTE_DATES';

export const REQUEST_MY_PRODUCTS = 'MY_REQUEST_PRODUCTS';
export const RECEIVE_MY_PRODUCTS = 'MY_RECEIVE_PRODUCTS';
export const REQUEST_PRODUCTS = 'REQUEST_PRODUCTS';
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';
export const REQUEST_FILTERS = 'REQUEST_FILTERS';
export const RECEIVE_FILTERS = 'RECEIVE_FILTERS';
export const UPDATE_PRODUCTS_PRINTER = 'UPDATE_PRODUCTS_PRINTER';

export const REQUEST_CART_ITEMS = 'REQUEST_CART_ITEMS';
export const RECEIVE_CART_ITEMS = 'RECEIVE_CART_ITEMS';
export const UPDATE_CART_ITEM_QTY = 'UPDATE_CART_ITEM_QTY';
export const REQUEST_PREVIOUSLY_PURCHASED_ITEMS = 'REQUEST_PREVIOUSLY_PURCHASED_ITEMS';
export const RECEIVE_PREVIOUSLY_PURCHASED_ITEMS = 'RECEIVE_PREVIOUSLY_PURCHASED_ITEMS';
export const REQUEST_RELATED_INK_ITEMS = 'REQUEST_RELATED_INK_ITEMS';
export const RECEIVE_RELATED_INK_ITEMS = 'RECEIVE_RELATED_INK_ITEMS';
export const REQUEST_RELATED_MAINTENANCE_ITEMS = 'REQUEST_RELATED_MAINTENANCE_ITEMS';
export const RECEIVE_RELATED_MAINTENANCE_ITEMS = 'RECEIVE_RELATED_MAINTENANCE_ITEMS';
export const REQUEST_SAVED_ITEMS = 'REQUEST_SAVED_ITEMS';
export const RECEIVE_SAVED_ITEMS = 'RECEIVE_SAVED_ITEMS';
export const REQUEST_SAVED_PRINTERS = 'REQUEST_SAVED_PRINTERS';
export const RECEIVE_SAVED_PRINTERS = 'RECEIVE_SAVED_PRINTERS';
export const REQUEST_PRINTER_SEARCH_RESULTS = 'REQUEST_PRINTER_SEARCH_RESULTS';
export const RECEIVE_PRINTER_SEARCH_RESULTS = 'RECEIVE_PRINTER_SEARCH_RESULTS';
export const UPDATE_SAVED_PRINTER = 'UPDATE_SAVED_PRINTER';
export const REMOVE_SAVED_PRINTER = 'REMOVE_SAVED_PRINTER';
export const REQUEST_CAROUSEL_ITEMS = 'REQUEST_CAROUSEL_ITEMS';
export const RECEIVE_CAROUSEL_ITEMS = 'RECEIVE_CAROUSEL_ITEMS';

export const UPDATE_PRODUCTS = 'UPDATE_PRODUCTS';

export const REQUEST_ADMIN_SALES = 'REQUEST_ADMIN_SALES';
export const RECEIVE_ADMIN_SALES = 'RECEIVE_ADMIN_SALES';
export const REQUEST_ADMIN_SALES_DATES = 'REQUEST_ADMIN_SALES_DATES';
export const RECEIVE_ADMIN_SALES_DATES = 'RECEIVE_ADMIN_SALES_DATES';
